import { createSlice } from "@reduxjs/toolkit";
import { purge } from "../Action/ActionSlice";
import { PURGE } from "redux-persist";
import { persistor } from "../store";


const initialState = {
    value:{
        id:'',
        access_menu:'',
        manu:[],
        access_submenu:'',
        permission:[],
        address:'',
        profile_img_url:'',
        role :'',
        role_id: 0,
        tp_cust_no : '',
        username : '',
        wholesaler_id :'',
        wholesaler_name :'',
        is_stock_allow_minus :false,
        menu_permission:'',
        all_permission:[],
        wholesaler_no_hp : '',
        update_access_menu : '',
        update_access_submenu : '',
        update_permission: '',
        arrayPermission : '',
        cashier:{
            id:'',
            id_activity:'',
            name:'',
            tanggal:'',
            time:'',
            saldo_in:'',
            saldo_out:'',
            saldo_adjustment:'',
        }
    },
    token:''
}

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        authLogin: (state, action) => {
            state.value.id = action.payload.id;
            state.value.access_menu = action.payload.access_menu;
            state.value.access_submenu = action.payload.access_submenu;
            state.value.menu = action.payload.menu;
            state.value.address = action.payload.address;
            state.value.profile_img_url = action.payload.profile_img_url;
            state.value.role = action.payload.role;
            state.value.role_id = action.payload.role_id;
            state.value.tp_cust_no = action.payload.tp_cust_no;
            state.value.username = action.payload.username;
            state.value.wholesaler_id = action.payload.wholesaler_id;
            state.value.wholesaler_name = action.payload.wholesaler_name;
            state.value.is_stock_allow_minus = action.payload.is_stock_allow_minus;
            state.value.no_hp = action.payload.no_hp;
            state.value.profile_image = action.payload.profile_image;
            state.value.permission = action.payload.permission.permission;
            state.value.all_permission = action.payload.permission.all_user_permission;
            state.value.menu_permission = action.payload.menu_permission;
            state.value.cashier={
            id:'',
            name:'',
            tanggal:'',
            time:'',
            saldo_in:'',
            saldo_out:'',
            saldo_adjustment:'',
        }
        },
        setToken: (state, action) => {
           state.token = action.payload.token 
        },
        setWholesalerId: (state, action) => {
            state.value.wholesaler_id = action.payload.wholesaler_id
            state.value.wholesaler_name = action.payload.wholesaler_name
            state.value.address = action.payload.address
            state.value.is_stock_allow_minus = action.payload.is_stock_allow_minus
            state.value.profile_img_url = action.payload.profile_img_url
        },
        authLogout: (state) => {
            
            state.value.id = '';
            state.value.access_menu = '';
            state.value.access_submenu = '';
            state.value.menu = [];
            state.value.address = "";
            state.value.profile_img_url = "";
            state.value.role = "";
            state.value.role_id = "";
            state.value.tp_cust_no = '';
            state.value.username = "";
            state.value.wholesaler_id = "";
            state.value.wholesaler_name = "";
            state.value.is_stock_allow_minus = false;
            state.value.no_hp = "";
            state.value.permission =[];
            state.value.all_permission = [];
            state.value.menu_permission ="";
            state.token = '';
            // persistor.purge();
            
        },
        accountAccessMenu:(s,a) => {

        },
        cashierCheckIn:(s,a)=>{
            s.value.cashier.name        = a.payload.name
            s.value.cashier.id          = a.payload.id
            s.value.cashier.id_activity         = a.payload.id_activity
            s.value.cashier.tanggal             = a.payload.tanggal
            s.value.cashier.time                = a.payload.time
            s.value.cashier.saldo_in            = a.payload.saldo_in
            s.value.cashier.saldo_out           = a.payload.saldo_out
            s.value.cashier.saldo_adjustment    = a.payload.saldo_adjustment
        },
        cashierCheckOut:(s,a)=>{
            s.value.cashier.name        = ''
            s.value.cashier.id          = ''
            s.value.tanggal             = ''
            s.value.time                = ''
            s.value.saldo_in            = ''
            s.value.saldo_out           = ''
            s.value.saldo_adjustment    = ''
        },
        extraReducers: (builder) => {
            builder.addCase(PURGE, (s) => {
              s.token = '';
              s.value.cashier={
                    id:'',
                    id_activity:'',
                    name:'',
                    tanggal:'',
                    time:'',
                    saldo_in:'',
                    saldo_out:'',
                    saldo_adjustment:'',
                }
            });
          },
       
    },
});

export const { authLogin, authLogout,setToken,setWholesalerId,cashierCheckIn,cashierCheckOut } = authSlice.actions;
export const selectToken = (state) => state.auth.token;
export default authSlice.reducer;